module.exports = __webpack_public_path__ + "img/组31.bcc15b96.png";